import { isPhoneViewport } from './mobileViewport';

export const applyDarkMode = (isDark: boolean) => {
  try {
    const root = document.documentElement;
    const allowFullDarkMode = isDark && !isPhoneViewport();

    root.style.setProperty('color-scheme', 'light');

    if (allowFullDarkMode) {
      root.classList.add('dark-mode');
      root.style.setProperty('--bg-primary', '#000000');
      root.style.setProperty('--bg-secondary', '#1a1a1a');
      root.style.setProperty('--text-primary', '#e5e5e5');
      root.style.setProperty('--text-secondary', '#a3a3a3');
      root.style.setProperty('--border-color', '#404040');
    } else {
      root.classList.remove('dark-mode');
      root.style.setProperty('--bg-primary', '#ffffff');
      root.style.setProperty('--bg-secondary', '#f9fafb');
      root.style.setProperty('--text-primary', '#334155');
      root.style.setProperty('--text-secondary', '#64748b');
      root.style.setProperty('--border-color', '#e5e7eb');
    }
  } catch {
    // no-op for SSR or restricted environments
  }
};




